export function doNothingFunc() {
  // do nothing
}
